import React, { useState } from 'react';
import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import { FaLinkedin, FaEnvelope } from 'react-icons/fa';

function Contact() {
  const [emailState, setEmailState] = useState('idle');
  const [challenge, setChallenge] = useState(null);
  const [userAnswer, setUserAnswer] = useState('');
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  const handleRevealClick = async () => {
    try {
      setError('');
      const res = await fetch('/api/challenge');
      const data = await res.json();
      setChallenge(data);
      setUserAnswer('');
      setEmailState('challenging');
    } catch {
      setError('Could not load challenge. Please try again.');
    }
  };

  const handleSubmitAnswer = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const res = await fetch('/api/verify-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ answer: userAnswer, token: challenge.token }),
      });
      const data = await res.json();
      if (res.ok) {
        setEmail(data.email);
        setEmailState('revealed');
      } else {
        setError(data.error || 'Incorrect. Please try again.');
        if (data.error && data.error.includes('expired')) {
          handleRevealClick();
        }
      }
    } catch {
      setError('Verification failed. Please try again.');
    }
  };

  const renderEmailCard = () => {
    if (emailState === 'revealed') {
      return (
        <a href={`mailto:${email}`}>
          <div className="contact-icon">
            <FaEnvelope />
          </div>
          <h5>Email</h5>
          <p>{email}</p>
        </a>
      );
    }

    if (emailState === 'challenging') {
      return (
        <>
          <div className="contact-icon">
            <FaEnvelope />
          </div>
          <h5>Quick Verification</h5>
          <p style={{ color: 'rgba(255,255,255,0.7)', marginBottom: '1rem' }}>
            {challenge?.question}
          </p>
          <Form onSubmit={handleSubmitAnswer} className="d-flex flex-column align-items-center gap-2">
            <Form.Control
              type="number"
              value={userAnswer}
              onChange={(e) => setUserAnswer(e.target.value)}
              placeholder="Your answer"
              style={{
                maxWidth: '160px',
                textAlign: 'center',
                borderRadius: '8px',
                border: '1px solid rgba(255,255,255,0.3)',
                background: 'rgba(255,255,255,0.1)',
                color: '#fff',
              }}
              autoFocus
            />
            <Button
              type="submit"
              variant="outline-light"
              size="sm"
              style={{ borderRadius: '20px', padding: '0.3rem 1.5rem' }}
            >
              Submit
            </Button>
          </Form>
          {error && (
            <p style={{ color: '#ff6b6b', fontSize: '0.85rem', marginTop: '0.5rem' }}>{error}</p>
          )}
        </>
      );
    }

    return (
      <div
        onClick={handleRevealClick}
        style={{ cursor: 'pointer' }}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === 'Enter' && handleRevealClick()}
      >
        <div className="contact-icon">
          <FaEnvelope />
        </div>
        <h5>Email</h5>
        <p>Click to reveal email address</p>
      </div>
    );
  };

  return (
    <section id="contact" className="contact-section section-padding">
      <Container>
        <div className="section-divider" style={{ background: 'linear-gradient(135deg, var(--accent), #ff6b6b)' }}></div>
        <h2 className="section-title" style={{ color: '#fff' }}>Get In Touch</h2>
        <p className="section-subtitle" style={{ color: 'rgba(255,255,255,0.7)' }}>
          Interested in working together? Let's connect.
        </p>

        <Row className="g-4 justify-content-center">
          <Col md={5}>
            <div className="contact-card">
              {renderEmailCard()}
            </div>
          </Col>
          <Col md={5}>
            <div className="contact-card">
              <a href="https://www.linkedin.com/in/johnwest72/" target="_blank" rel="noopener noreferrer">
                <div className="contact-icon">
                  <FaLinkedin />
                </div>
                <h5>LinkedIn</h5>
                <p>linkedin.com/in/johnwest72</p>
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Contact;
